import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export const BannerBottom = ({ children }: Props) => {
  return <div className="max-xl:hidden">{children}</div>
}
